import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import BodyText from 'Components/ComponentLibrary/Atoms/Text/BodyText';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { dispatchAuthenticationFactorsRefresh } from 'Hooks/useRefreshEvent';
import { useSnackbarContext } from 'Context/SnackbarContext';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import RoundedButton from 'Components/ComponentLibrary/Atoms/Inputs/RoundedButton';
import CenteredActions from 'Views/Page/Content/Modal/Components/CenteredActions';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';

const styles = (theme) => ({
  root: {},
  field: {
    marginTop: theme.spacing(4),
  },
});

const EnterVerificationCode = ({
  className,
  classes,
}) => {
  const { onSubmit } = useMetaLayoutContext();
  const { clearModalCollection } = useModalContext();
  const { displaySuccess } = useSnackbarContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  const handleSubmit = async () => {
    const resp = await onSubmit();

    // resp will only be set if submission is successful (see useMetaFormBuilder handleSubmit for details)
    if (resp) {
      displaySuccess('Authenticator App Enabled');
      logStandardizedEvent(categories.userSettingsSecurity, eventTypes.clickButton, 'Auth Factor Authenticator: Submit verification code');
      dispatchAuthenticationFactorsRefresh();
      clearModalCollection();
    }
  };

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <BodyText
        text={'Enter the one-time six digit code provided by your authentication app.'}
      />
      <MetaControlField className={classes.field} attr={'code'} />
      <CenteredActions>
        <RoundedButton
          fullWidth
          onClick={handleSubmit}
          test={'security-settings-button-authenticatorApp-register-modal-submit-code'}
        >
          {'Continue'}
        </RoundedButton>
      </CenteredActions>
    </Box>
  );
};

EnterVerificationCode.defaultProps = {
  className: '',
};

EnterVerificationCode.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(EnterVerificationCode);
